import { TOfferCard } from '../types/offer';

type TOfferProps = Pick<TOfferCard, 'phones'>;

export function getOfferPhone(offer: TOfferProps) {
  if (offer.phones?.length) {
    const phone = offer.phones[0];

    return phone && phone.number
      ? `${phone.countryCode && phone.countryCode.startsWith('+') ? '' : '+'}${phone.countryCode}${phone.number}`
      : '';
  }

  return undefined;
}

export function formatOfferPhone(phone: string) {
  return phone ? `${phone.startsWith('+') ? '' : '+'}${phone}` : '';
}
